import React, { useState, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Inputbox from "../Component/Inputbox";
import { BiSolidHide, BiShow } from "react-icons/bi";
import Button from "../Component/Button";
import { showToast } from "../helper/Toster";
import REACT_APP_API_URL from "../utils/constant.js";
import Logo from "../assets/Image/logo.png";

const NewPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [token, setToken] = useState("");
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [error, setError] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!isPasswordVisible);
  };
  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible(!isConfirmPasswordVisible);
  };

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tokenVal = queryParams.get("token");
  const navigate = useNavigate();

  useEffect(() => {
    const storedToken = tokenVal;

    if (storedToken) {
      setToken(storedToken);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {
      newPassword: "",
      confirmPassword: "",
    };

    let valid = true;

    if (!newPassword) {
      newErrors.newPassword = "Please enter new password";
      valid = false;
    } else if (newPassword.trim() === "") {
      newErrors.newPassword = "Spaces are not allowed.";
      valid = false;
    }

    if (!confirmPassword.trim()) {
      newErrors.confirmPassword = "Please enter confirm password";
      valid = false;
    } else if (confirmPassword.trim() === "") {
      newErrors.confirmPassword = "Spaces are not allowed.";
      valid = false;
    }

    if (newPassword && confirmPassword && newPassword !== confirmPassword) {
      newErrors.confirmPassword =
        "New password and Current password does not match.";
      valid = false;
    }

    setError(newErrors);

    if (!valid) return;

    setLoading(true);

    try {
      let result = await fetch(`${REACT_APP_API_URL}admin-reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          forgot_token: token,
          newPassword: newPassword,
          confirmPassword: confirmPassword,
        }),
      });
      result = await result.json();
      console.log(result);
      if (result && result.success === "true") {
        showToast("success", "Password update successfully");
        navigate("/login");
      } else if (result.success === "false") {
        showToast("error", result.message);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  return (
    <div className="position-relative">
      {loading && (
        <div id="loader_class" className="loader-overlay">
          <div className="loader"></div>
        </div>
      )}
      <div className="container-xxl">
        <div className="authentication-wrapper authentication-basic container-p-y">
          <div className="authentication-inner">
            <div className="card px-sm-6 px-0">
              <div className="card-body">
                <div className="mb-4 text-center">
                  <img src={Logo} alt="" height={120} />
                </div>
                <h4 className="mb-1 text-start">Reset Password 🔒</h4>
                <p class="mb-6">
                  Your new password must be different from previously used
                  passwords
                </p>

                <form
                  id="formAuthentication"
                  className=""
                  action="/login"
                  method=""
                >
                  <div className="mb-6 position-relative">
                    <label
                      htmlFor="password"
                      className="form-label fw-semibold"
                    >
                      New Password
                    </label>
                    <Inputbox
                      type={isPasswordVisible ? "text" : "password"}
                      placeholder="Enter your password"
                      className="form-control"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                    />
                    {error.newPassword && (
                      <small className="text-danger">{error.newPassword}</small>
                    )}
                    <div
                      className="password-show position-absolute"
                      onClick={togglePasswordVisibility}
                    >
                      {isPasswordVisible ? <BiShow /> : <BiSolidHide />}
                    </div>
                  </div>
                  <div className="mb-6 position-relative">
                    <label
                      htmlFor="password"
                      className="form-label fw-semibold"
                    >
                      Confirm Password
                    </label>
                    <Inputbox
                      type={isConfirmPasswordVisible ? "text" : "password"}
                      placeholder="Enter your password"
                      className="form-control"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    {error.confirmPassword && (
                      <small className="text-danger">
                        {error.confirmPassword}
                      </small>
                    )}
                    <div
                      className="password-show position-absolute"
                      onClick={toggleConfirmPasswordVisibility}
                    >
                      {isConfirmPasswordVisible ? <BiShow /> : <BiSolidHide />}
                    </div>
                  </div>

                  <div className="">
                    <Button
                      className=" w-100"
                      type="submit"
                      onClick={handleSubmit}
                    >
                      Set new password
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewPassword;
